module.exports = __webpack_public_path__ + "img/garlic.be5030ca.webp";